import FreespinsWheelRecord from "integration/records/freespins-wheel-record";
import WheelBonusRecord from "integration/records/wheel-bonus-record";
import { User } from "slotworks/integration/revolver/schema/spin-record-schema";
import Gameplay from "slotworks/model/gameplay/gameplay-model";
import Record from "slotworks/model/gameplay/records/record";
import { RecordBuilder } from "slotworks/server/builders/record-builder";

class FreespinsWheelRecordBuilderBase implements RecordBuilder {

    public filter(data: any): boolean {
        let wheelResponse: FreespinsWheelResponseSchema;

        if (data && data.data) {
            wheelResponse = data.data as FreespinsWheelResponseSchema;
        }

        return wheelResponse && wheelResponse.RESULTS !== undefined && wheelResponse.RESULTS.game === "FREESPIN_WHEEL_BONUS";
    }

    public build(gameplay: Gameplay, data: any): Record[] {
        const wheelResponse: FreespinsWheelResponseSchema = data.data as FreespinsWheelResponseSchema;

        const record = new FreespinsWheelRecord();
        record.is_complete = wheelResponse.RESULTS.state.is_complete;
        record.giftedAdditional = wheelResponse.RESULTS.state.giftedAdditional;
        record.creditsWon = wheelResponse.RESULTS.total_win_cash;
        record.spinsWon = wheelResponse.RESULTS.state.spins_won;
        record.total = wheelResponse.RESULTS.state.total;
        record.remain = wheelResponse.RESULTS.state.remain;
        record.spins = wheelResponse.RESULTS.state.spins;
        return [record];
    }

}
const FreespinsWheelRecordBuilder = new FreespinsWheelRecordBuilderBase();
export default FreespinsWheelRecordBuilder;

export interface FreespinsWheelResponseSchema {
    RESULTS: Results;
    USER: User;
    time: number;
}

export interface Results {
    additionalData: any;
    eval: Eval;
    game: string;
    next_game: string;
    games_pending: boolean;
    round_id: number;
    total_bet_cash: number;
    total_win_cash: number;
    state: State;
}

export interface Eval {
    freeSpinsCount: number;
    multiplier: number;
    version: string;
}

export interface State {
    buyoutGame: boolean;
    giftedAdditional: number;
    rounds: number;
    is_complete: boolean;
    is_retrigger: boolean;
    game: string;
    total_win_cash: number;
    total: number;
    remain: number;
    spins: number;
    spins_won: number;
    retriggers: number;
    spin_pending: boolean;
    total_base_game_win_amount: number;
    total_bonus_games_win_amount: number;
}